import pathOr from 'ramda/src/pathOr'
import isEmpty from 'ramda/src/isEmpty'
import pipe from 'ramda/src/pipe'

export default state => !pipe(
	pathOr([], ['app', 'userData', 'tokens']),
	isEmpty,
)(state)
